import WizTag3dPositionManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'wiz-tag-3d-position-management-tongre',
  title: '设备点位设置',
  version: '0.1.0',
  description: '设备点位设置',
  routes: WizTag3dPositionManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'IOTDeviceTemplateApi',
      'DataCategoryApi',
      'IOTDeviceApi',
      'IOTDeviceProtocolInstanceApi',
      'DataCategoryApi',
      'Tag3DPositionApi',
      'Tag3DPositionImgApi',
    ],
  },
  config: {
    cloudServer: 'ws://renderapi.wiz.top:8082',
    cloudProtocol: 'ws',
    modelFileList: [
      {
        filePath: 'data://../apps/BL/models/bl.pr',
        fileName: '博罗.pr',
      },
    ],
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
